/*
 * Created by alex@hackerbay.com on 3.1.2019
 * Copyright Singularity Technologies GmbH (c) 2019. All rights reserved
 */

import * as React from "react";
import {translate, Trans} from "react-i18next";
import i18n from "i18next";
import {Header} from "../../components/Header";
import TextBody from "../../components/TextBody";
import BottomBar from "../../components/BottomBar";
import TopNav from "../../components/TopNav";
import {Col, Container, Row} from "reactstrap";
import StatusOverview from "../../components/StatusBar";
import Subtitle from "../../components/Subtitle";
import StackedBottomButtonPair from "../../components/StackedBottomButtonPair";
import iconInfoDocs from "../../media/icons/infoDocs.svg"
import BigIconButton from "../../components/BigIconButton";
import StatusBar from "../../components/StatusBar";
import {SpacerRow} from "../../components/SpacerRow";
import {BrowserView,MobileView,isMobile} from "react-device-detect";
import {StatusBarDesktop} from "../../components/StatusBarDesktop";
import iconMicLetter from "../../media/icons/mic-letter.png"
import technicianAppointmentRequired from "../../technicianRequired";
import {hardwareWasShipped} from "../../hardwareHelper";
import vodafoneLogo from "../../media/icons/vf-logo.png";

class Stage9RouterSetupPage extends React.Component {
    constructor(props){
        super(props);
    }

    render() {

        const youtubeEmbedSrc = `https://www.youtube.com/embed/${this.props.orderStatus ? this.props.orderStatus.shipping.youtubeVideoId : "-W9XzJn1viI" }`;

		/**
		 * Top Navigation / "Footer" Link
		 */
		const footerLnk = <TopNav
			buttonTextResource={"footer_link"}
			buttonOnClick={this.props.openTopNav}
		/>;

        return <Container>
            <MobileView>
                <Row>
                    <Col xs={2} style={{marginTop:"15px"}}>
                        <img src={vodafoneLogo} className={"img-fluid"}  alt={"Vodafone Logo"}/>
                    </Col>
                    {footerLnk}
                </Row>
                <StatusBar
                    currentStage={this.props.currentStage}
                    technicianAppointmentRequired={technicianAppointmentRequired(this.props.ds360APIResult)}
                    customerWillGetAPackage={hardwareWasShipped(this.props.orderStatus)}
                />
                <SpacerRow/>
                <Header
                    textResource={"router_setup_title"}
                />
                <SpacerRow/>
                <TextBody
                    textResource={"router_setup_body_mobile"}
                />
                <span className={"fixed-to-bottomX"}>
                    <Subtitle
                        textResource={"router_setup_instructions"}
                    />
                    <Row>
                        <Col xs={12}>
                            <div style={{width:"100%", height:"200px"}}>
                                <iframe
                                    width="100%"
                                    height="100%"
                                    src={youtubeEmbedSrc}
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen={true}
                                />
                            </div>

                        </Col>
                    </Row>
                    <StackedBottomButtonPair
                        upperButtonTextResource={"i_am_online"}
                        upperButtonOnClick={this.props.nextStage}
                        lowerButtonTextResource={"there_was_a_problem"}
                        lowerButtonOnClick={this.props.contactVodafoneCallback}
                    />
                </span>
            </MobileView>

            <BrowserView>
                <Row>
                {footerLnk}
                </Row>
                <StatusBarDesktop
                    currentStage={this.props.currentStage}
                    technicianAppointmentRequired={technicianAppointmentRequired(this.props.ds360APIResult)}
                    customerWillGetAPackage={hardwareWasShipped(this.props.orderStatus)}
                />
                <Row>
                    <Col xs={7}  lg={{ size: 5, offset: 1 }} style={{marginTop:"12px"}}>
                        <Header
                            textResource={"router_setup_title"}
                        />
                        <SpacerRow/>
                        <TextBody
                            textResource={"router_setup_body_desktop"}
                        />

                        <SpacerRow/>
                        <SpacerRow/>
                        <SpacerRow/>
                        <Row>
                            <Col xs={3}>
                                <img src={iconMicLetter} alt={"mic letter icon"} className={"img-fluid"} />
                            </Col>
                            <Col xs={6}>
                                <Subtitle
                                    textResource={"router_setup_subtext_desktop"}
                                />
                            </Col>
                        </Row>

                    </Col>
                    <Col xs={5}  lg={{ size: 4, offset: 1 }} className={"round-corners shadow bg-white"}>
                        <SpacerRow/>
                        <Header
                            showDesktopVersionSub={true}
                            textResource={"Router-Installation"}
                        />
                        <SpacerRow/>
                        <Row>
                            <Col xs={12}>
                                <div style={{width:"100%", height:"200px"}}>
                                    <iframe
                                        width="100%"
                                        height="100%"
                                        src={youtubeEmbedSrc}
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen={true}
                                    />
                                </div>
                            </Col>
                        </Row>
                        <SpacerRow/>
                        <StackedBottomButtonPair
                            upperButtonTextResource={"i_am_online"}
                            upperButtonOnClick={this.props.nextStage}
                            lowerButtonTextResource={"there_was_a_problem"}
                            lowerButtonOnClick={this.props.contactVodafoneCallback}
                            showDesktopVersion={true}
                        />
                    </Col>
                </Row>
            </BrowserView>
        </Container>
    }
}

export default translate("translations")(Stage9RouterSetupPage);
